<!-- ContentPagination.vue -->
<template>
  <nav class="com_pagenation1">
    <ul>
      <li class="prev" :class="{ disabled: currentPage <= 1 }">
        <a href="#" @click.prevent="changePage(currentPage - 1)"
          >前の{{ itemsPerPage }}件</a
        >
      </li>
      <li
        v-for="page in pages"
        :key="page"
        class="item"
        :class="{ active: currentPage === page, ellipsis: page === '...' }"
      >
        <a v-if="page !== '...'" href="#" @click.prevent="changePage(page)">{{
          page
        }}</a>
        <span v-else>{{ page }}</span>
      </li>
      <li class="next" :class="{ disabled: currentPage >= totalPages }">
        <a href="#" @click.prevent="changePage(currentPage + 1)"
          >次の{{ itemsPerPage }}件</a
        >
      </li>
    </ul>
  </nav>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "ContentPagination",
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      required: true,
    },
  },
  emits: ["page-changed"],
  setup(props, { emit }) {
    const pages = computed<(number | string)[]>(() => {
      const range: (number | string)[] = [];
      const { totalPages, currentPage } = props;

      if (totalPages <= 7) {
        for (let i = 1; i <= totalPages; i++) {
          range.push(i);
        }
      } else {
        if (currentPage <= 4) {
          range.push(1, 2, 3, 4, 5, "...", totalPages);
        } else if (currentPage > totalPages - 4) {
          range.push(
            1,
            "...",
            totalPages - 4,
            totalPages - 3,
            totalPages - 2,
            totalPages - 1,
            totalPages
          );
        } else {
          range.push(
            1,
            "...",
            currentPage - 1,
            currentPage,
            currentPage + 1,
            "...",
            totalPages
          );
        }
      }
      return range;
    });

    const changePage = (page: number | string) => {
      if (typeof page === "number" && page >= 1 && page <= props.totalPages) {
        emit("page-changed", page);
      }
    };

    return {
      pages,
      changePage,
    };
  },
});
</script>

<style scoped>
.com_pagenation1 {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.com_pagenation1 ul {
  list-style: none;
  display: flex;
  padding: 0;
  margin: 0;
}

.com_pagenation1 li {
  margin: 0 5px;
}

.com_pagenation1 .prev.disabled a,
.com_pagenation1 .next.disabled a {
  pointer-events: none;
  color: grey;
}

.com_pagenation1 .item.active a {
  font-weight: bold;
}

.com_pagenation1 .item.ellipsis {
  pointer-events: none;
}
</style>
